































import {Component} from 'vue-property-decorator';
import Slide from '@/presentation/slides/Slide';

@Component({components: {}})
export default class Liability extends Slide {
  closeFullscreen() {
    const elem: any = document;
    if (elem.exitFullscreen) {
      elem.exitFullscreen();
    } else if (elem.mozCancelFullScreen) { /* Firefox */
      elem.mozCancelFullScreen();
    } else if (elem.webkitExitFullscreen) { /* Chrome, Safari and Opera */
      elem.webkitExitFullscreen();
    } else if (elem.msExitFullscreen) { /* IE/Edge */
      elem.msExitFullscreen();
    }
  }

  get userName() {
    if (this.data.Meta === null) {
      return '';
    }
    return `${this.data.Meta.FirstName} ${this.data.Meta.LastName}`;
  }
}
